import React, { Component } from "react";
import Store from "../../content/Store";
import styles from "../../assets/css/modules/myprofile/change-phone-number-line.css";
import Content from "../../content/Content";
import Countries from "../../constants/Countries";
import { isValidPhoneNumber } from "../../validations/PhoneNumberValidation";
import { connect } from "react-redux";
import {
  changePhoneNumber,
  deletePhoneNumber
} from "../../actions/changephonenumber/ChangePhoneNumberActions";
import { sendDataLayerEvent } from "../../analytics/google/GoogleTagManagerDataLayerEvents";
import { GoogleTagManagerConstants } from "../../analytics/google/GoogleTagManagerConstants";

export const updateEventActions = {
  Mobile: "mobile-telephone",
  WorkMobile: "work-mobile-telephone",
  Home: "home-telephone",
  Work: "work-telephone"
};

const sendEventToGoogleTagManagerAboutUpdate = (phoneNumberType) => {
  if (updateEventActions[phoneNumberType]) {
    sendDataLayerEvent({
      event: GoogleTagManagerConstants.eventTypes.updateContactDetailsEvent,
      eventAction: updateEventActions[phoneNumberType]
    });
  }
};

const mapStateToProps = ({ policyReducer = {} }) => {
  return {
    MembershipNumber:
      policyReducer.selectedPolicy &&
      policyReducer.selectedPolicy.MembershipNumber
  };
};

class ChangePhoneNumberLine extends Component {
  constructor(props) {
    super(props);
    this.state = {
      editMode: false,
      currentInternationalCode: "44",
      areaCode: "",
      localNumber: "",
      validationErrors: [],
      telephoneUpdateSuccess: false,
      deleteMode: false
    };
    this.handleEdit = this.handleEdit.bind(this);
    this.handleCancel = this.handleCancel.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.validateTelephoneModel = this.validateTelephoneModel.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.handleDeleteCancel = this.handleDeleteCancel.bind(this);
    this.onSubmitDelete = this.onSubmitDelete.bind(this);
  }

  setGenericValidationError() {
    this.setState({
      validationErrors: [
        Store.ChangePhoneNumberLine.ValidationErrors.GenericError
      ]
    });
  }

  handleEdit(event) {
    event.preventDefault();
    this.setState({
      editMode: true,
      validationErrors: []
    });
    this.props.HandleEdit();
  }

  handleDelete(event) {
    event.preventDefault();
    this.setState({
      deleteMode: true,
      validationErrors: []
    });
    this.props.HandleEdit();
  }

  handleCancel(event) {
    event.preventDefault();
    this.setState({
      editMode: false,
      currentInternationalCode: "44",
      validationErrors: []
    });
    this.props.CallBackParent();
  }

  handleDeleteCancel(event) {
    event.preventDefault();
    this.setState({
      deleteMode: false,
      validationErrors: []
    });
    this.props.CallBackParent();
  }

  onSubmit(event) {
    event.preventDefault();
    this.setState({ validationErrors: [], telephoneUpdateSuccess: false });

    const telephoneModel = {
      AreaCode: this.state.areaCode,
      IntlCode: this.state.currentInternationalCode,
      LocalNumber: this.state.localNumber,
      Type: this.props.Telephone.Type
    };

    let errors = this.validateTelephoneModel(telephoneModel);
    if (errors.length > 0) {
      this.setState({ validationErrors: errors });
      return;
    }
    this.props
      .changePhoneNumber(this.props.MembershipNumber, telephoneModel)
      .then(() => {
        sendEventToGoogleTagManagerAboutUpdate(this.props.Telephone.Type);
        this.setState({ telephoneUpdateSuccess: true, editMode: false });
        this.props.CallBackParent();
      })
      .catch(() => {
        this.setGenericValidationError();
      });
  }

  onSubmitDelete(event) {
    event.preventDefault();
    this.setState({
      validationErrors: [],
      telephoneUpdateSuccess: false
    });

    this.props
      .deletePhoneNumber(this.props.MembershipNumber, this.props.Telephone.Type)
      .then(() => {
        sendEventToGoogleTagManagerAboutUpdate(this.props.Telephone.Type);
        this.setState({ telephoneUpdateSuccess: true, deleteMode: false });
        this.props.CallBackParent();
      })
      .catch(() => {
        this.setGenericValidationError();
      });
  }

  validateTelephoneModel(telephoneModel = {}) {
    let errors = [];

    if (
      !telephoneModel.AreaCode ||
      !isValidPhoneNumber(telephoneModel.AreaCode)
    ) {
      errors.push(Store.ChangePhoneNumberLine.ValidationErrors.InvalidAreaCode);
    }

    if (
      !telephoneModel.LocalNumber ||
      !isValidPhoneNumber(telephoneModel.LocalNumber)
    ) {
      errors.push(
        Store.ChangePhoneNumberLine.ValidationErrors.InvalidPhoneNumber
      );
    }

    return errors;
  }

  render() {
    const nonModularButtonClasses = "btn btn-link";
    const nonModularFormClasses = "form-control form-control-sm";

    return (
      <div
        className={
          styles.changePhoneNumberLine +
          (this.state.deleteMode
            ? " " + styles.changePhoneNumberLineFullWidth
            : "")
        }
        id={"phoneLine_" + this.props.Telephone.Type}
      >
        <strong>{this.props.Telephone.PhoneNumberType}</strong>
        <span>
          {this.props.Telephone.Number ||
            Store.MyProfile.MemberPhone.NoNumberHeld}
          {this.state.telephoneUpdateSuccess ? (
            <i className="icon-check-green ml-2 mt-1" />
          ) : null}
        </span>

        {!this.state.editMode &&
        !this.props.DisableEdit &&
        !this.state.deleteMode ? (
          <button
            id={"edit_" + this.props.Telephone.Type}
            onClick={this.handleEdit}
            className={`${nonModularButtonClasses} ${styles.btnStyles}`}
          >
            <i className="icon-gear" />{" "}
            <Content name={Store.GeneralPages.ButtonEditText} />
          </button>
        ) : null}

        {this.props.Telephone.Number &&
        !this.state.deleteMode &&
        !this.state.editMode &&
        !this.props.DisableEdit ? (
          <button
            id={"delete_" + this.props.Telephone.Type}
            onClick={this.handleDelete}
            className={`${nonModularButtonClasses} ${styles.btnStyles}`}
            disabled={this.props.disabled}
          >
            <i className="icon-cross-orange" />{" "}
            <Content name={Store.GeneralPages.ButtonDeleteText} />
          </button>
        ) : null}

        {this.state.validationErrors.length > 0 ? (
          <div id="validationErrors" className="alert alert-danger">
            <p className="alert-heading mb-1">
              <strong>
                <Content name={Store.GeneralPages.CorrectErrors} />
              </strong>
            </p>
            <ul>
              {this.state.validationErrors.map((error, index) => (
                <li key={index}>
                  <Content name={error} />
                </li>
              ))}
            </ul>
          </div>
        ) : null}

        {this.state.deleteMode ? (
          <div
            id={"deleteSection_" + this.props.Telephone.Type}
            className={"input-tooltip " + styles.toolTip}
          >
            <p>
              <Content
                name={Store.ChangePhoneNumberLine.DeleteConfirmTooltip}
              />
            </p>

            <button
              id={"deleteYes_" + this.props.Telephone.Type}
              onClick={this.onSubmitDelete}
              className={`${nonModularButtonClasses} ${styles.btnStyles}`}
            >
              <i className="icon-check-green" />{" "}
              <Content name={Store.GeneralPages.ButtonYesText} />
            </button>

            <button
              id={"deleteNo_" + this.props.Telephone.Type}
              onClick={this.handleDeleteCancel}
              className={`${nonModularButtonClasses} ${styles.btnStyles}`}
            >
              <i className="icon-cross-orange" />{" "}
              <Content name={Store.GeneralPages.ButtonNoText} />
            </button>
          </div>
        ) : null}

        {this.state.editMode ? (
          <form
            className={"form-inline " + styles.formRow}
            id={"updateSection_" + this.props.Telephone.Type}
          >
            <div className="form-group">
              <span className={styles.countryCodeCode}>
                +{this.state.currentInternationalCode}
              </span>
              <input
                className={`${nonModularFormClasses} ${styles.phoneNumber} ${styles.areaCode}`}
                type="text"
                placeholder="Area Code"
                id={"areaCode_" + this.props.Telephone.Type}
                defaultValue={this.state.areaCode}
                onChange={(e) =>
                  this.setState({
                    areaCode: e.target.value
                  })
                }
              />
            </div>
            <div className={"form-group " + styles.phoneNumberFormGroup}>
              <input
                className={`${nonModularFormClasses} ${styles.phoneNumber}`}
                type="text"
                placeholder="Number"
                id={"localNumber_" + this.props.Telephone.Type}
                defaultValue={this.state.localNumber}
                onChange={(e) =>
                  this.setState({
                    localNumber: e.target.value
                  })
                }
              />
            </div>
            <div className={"form-group " + styles.flexFix}>
              <select
                className={`${nonModularFormClasses} ${styles.countryCode}`}
                id={"intlCode_" + this.props.Telephone.Type}
                onChange={(event) => {
                  this.setState({
                    currentInternationalCode: event.target.value
                  });
                }}
              >
                {Countries.map((country) => (
                  <option
                    key={country[0]}
                    value={country[1]}
                    selected={country[0].toLowerCase() === "united kingdom"}
                  >
                    {country[0]}
                  </option>
                ))}
              </select>
            </div>
            <button
              id={"update_" + this.props.Telephone.Type}
              className={`${nonModularButtonClasses} ${styles.btnStyles}`}
              type="submit"
              onClick={this.onSubmit}
              disabled={this.props.disabled}
            >
              <i className="icon-check-green" />{" "}
              <Content name={Store.GeneralPages.ButtonUpdateText} />
            </button>
            <button
              id={"cancel_" + this.props.Telephone.Type}
              onClick={this.handleCancel}
              className={`${nonModularButtonClasses} ${styles.btnStyles}`}
            >
              <i className="icon-cross-orange" />
              <Content name={Store.GeneralPages.ButtonCancelText} />
            </button>
          </form>
        ) : null}
      </div>
    );
  }
}

export default connect(mapStateToProps, {
  changePhoneNumber,
  deletePhoneNumber
})(ChangePhoneNumberLine);
